module.exports = __webpack_public_path__ + "img/wlodek.6f6374d7.jpg";